import {
    createSelector,
} from 'reselect';

export const getTourId = state => state.data.getIn(['tour', 'id']);
export const getTours = state => state.data.getIn(['tour', 'byId']).toList();
export const getFloors = state => state.data.getIn(['floor', 'byId']).toList();
export const getRooms = state => state.data.getIn(['room', 'byId']).toList();
export const getInfoPoints = state => state.data.getIn(['infopoint', 'byId']).toList();
export const getUpload = state => state.upload;

export const tourSelector = createSelector(
    [getTourId, getTours, getFloors, getRooms, getInfoPoints],
    (tour_id, tours, floors, rooms, infopoints) => {
        const tour = tours.find(tour => tour.get('id') === tour_id);
        return tour ?
            tour.set(
                'floors',
                floors
                    .filter(floor => floor.get('tour_id') === tour_id)
                    .sort((a, b) => a.get('sort') - b.get('sort'))
                    .map(floor => floor
                        .set(
                            'rooms',
                            rooms
                                .filter(room => room.get('floor_id') === floor.get('id'))
                                .sort((a, b) => a.get('sort') - b.get('sort'))
                                .map(room => room
                                    .set('infopoints',
                                        infopoints
                                            .filter(infopoint => infopoint.get('room_id') === room.get('id')), // eslint-disable-line max-nested-callbacks
                                    ),
                                ),
                        )
                        .set(
                            'infopoints',
                            infopoints
                                .filter(infopoint => infopoint.get('floor_id') === floor.get('id')),
                        ),
                    ),
            )
            .set('rooms', rooms)
            .set('infopoints', infopoints)
            : undefined;
    },
);
